<template>
  <div class="layouts">
    <div class="nav_content">
      <div class="left" @click="back"><i class="el-icon-arrow-left"></i></div>
      <div class="title">{{ lang.yygg }}</div>
    </div>
    <div class="radio-group">
      <van-radio-group v-model="radio">
        <van-cell-group>
          <van-cell  class="cell"  >
            <template #title>
              <span class="name">English</span>
            </template>
            <template #right-icon>
              <van-radio name="en" @click="radio = 'en'" checked-color="#c0dd2b" />
            </template>
          </van-cell>
        </van-cell-group>
      </van-radio-group>
      <van-radio-group v-model="radio">
        <van-cell-group>
          <van-cell  class="cell"  >
            <template #title>
              <span class="name">日本語</span>
            </template>
            <template #right-icon>
              <van-radio name="jap" @click="radio = 'jap'" checked-color="#c0dd2b" />
            </template>
          </van-cell>
        </van-cell-group>
      </van-radio-group>

      <van-radio-group v-model="radio">
        <van-cell-group>
          <van-cell  class="cell"  >
            <template #title>
              <span class="name">Deutsch</span>
            </template>
            <template #right-icon>
              <van-radio name="de" @click="radio = 'de'" checked-color="#c0dd2b" />
            </template>
          </van-cell>
        </van-cell-group>
      </van-radio-group>
      <van-radio-group v-model="radio">
        <van-cell-group>
          <van-cell  class="cell"  >
            <template #title>
              <span class="name">Espana</span>
            </template>
            <template #right-icon>
              <van-radio name="es" @click="radio = 'es'" checked-color="#c0dd2b" />
            </template>
          </van-cell>
        </van-cell-group>
      </van-radio-group>
      <van-radio-group v-model="radio">
        <van-cell-group>
          <van-cell  class="cell"  >
            <template #title>
              <span class="name">Tiếng Việt </span>
            </template>
            <template #right-icon>
              <van-radio name="vi" @click="radio = 'vi'" checked-color="#c0dd2b" />
            </template>
          </van-cell>
        </van-cell-group>
      </van-radio-group>
      <van-radio-group v-model="radio">
        <van-cell-group>
          <van-cell  class="cell"  >
            <template #title>
              <span class="name">ltaliano</span>
            </template>
            <template #right-icon>
              <van-radio name="it" @click="radio = 'it'" checked-color="#c0dd2b" />
            </template>
          </van-cell>
        </van-cell-group>
      </van-radio-group>
      <van-radio-group v-model="radio">
        <van-cell-group>
          <van-cell  class="cell"  >
            <template #title>
              <span class="name">한국어</span>
            </template>
            <template #right-icon>
              <van-radio name="ko" @click="radio = 'ko'" checked-color="#c0dd2b" />
            </template>
          </van-cell>
        </van-cell-group>
      </van-radio-group>
      <van-radio-group v-model="radio">
        <van-cell-group>
          <van-cell  class="cell"  >
            <template #title>
              <span class="name">简体中文</span>
            </template>
            <template #right-icon>
              <van-radio name="cn" @click="radio = 'cn'" checked-color="#c0dd2b" />
            </template>
          </van-cell>
        </van-cell-group>
      </van-radio-group>
      <van-radio-group v-model="radio">
        <van-cell-group>
          <van-cell  class="cell"  >
            <template #title>
              <span class="name">繁体中文</span>
            </template>
            <template #right-icon>
              <van-radio name="cnt" @click="radio = 'cnt'" checked-color="#c0dd2b" />
            </template>
          </van-cell>
        </van-cell-group>
      </van-radio-group>
    </div>
    <div class="botton" @click="selectLang">
      <div class="confirm-button">{{ lang.confirm }}</div>
    </div>
  </div>

</template>

<script type="text/javascript">
import store from "../store";
import { CONF,API_SERVER } from '@/assets/js/config'
import {mapState} from "vuex";

export default {
  data() {
    return {
      apiSer: "",
      radio: "" ,
    }
  },
  computed: {
    ...mapState(['lang'])
  },
  created() {
    let lang = sessionStorage.getItem('lang')
    if (!lang ) {
      this.radio = CONF.LANG
    }else {
      this.radio = lang
    }
    console.log(this.radio)
  },
  methods: {
    back(){
      this.$router.back()
    },
    selectLang(){
      CONF.LANG = this.radio
      this.$indicator.open(this.lang.loading);
      sessionStorage.removeItem('lang')
      sessionStorage.setItem('lang', this.radio)
      this.$xhrGet('/system/translate').then(res => {
        store.state.lang = res.data
        this.$indicator.close();
        store.commit("SET_TRANSLATE",res.data)
        this.back()
      })

    },
  }
}
</script>


<style>
.layouts{
  background: #000;
  color: #fff;
  height: 100%;
  padding: 0 20px;
  position: relative;
}
.nav_content {
  padding:20px;
  display: flex;
  justify-content: center;
  align-items: center;
}
.nav_content .left{
  position: absolute;
  left: 20px;
  font-size: 20px;
  font-weight: 600;
}
.nav_content .title{
  font-size: 20px;
  font-weight: 600;
}
.radio-group{
}
.cell{
  background: #000;
  color: #fff;
}
.name{
  font-size: 18px;
  font-weight: 600;
}
.botton {
  margin-top: 40px;
}
.botton .confirm-button{
  font-weight: 600;
  font-size: 16px;
  color: #000;
  width: 100%;
  height: 48px;
  background: #c0dd2b;
  border-radius: 13px;
  text-align: center;
  line-height: 48px;
  margin-top: 24px;
}




</style>
